import { createFeatureSelector } from '@ngrx/store';

import * as fromRootStore from '../../store';
import * as fromMessages from './reducers/message-reducers';

export const reducers = {
  messages: fromMessages.default
};

export interface NotificationsState {
  messages: fromMessages.State;
}

// This is a lazy loaded state, so we need to extend from the App Root State
export interface State extends fromRootStore.State {
  notifications: NotificationsState;
}

export const getNotificationsRootState = createFeatureSelector<NotificationsState>('notifications');
